
function TpaAdvRec() {
    return (
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xxl-12">
                        <div class="card">
                            <div class="card-body">
                                <h5>TPA Advance Receipt</h5>
                                <br />
                                <div class="live-preview">
                                    <form action="javascript:void(0);">
                                        <div class="row">

                                            <div class="col-md-3">
                                                <div >
                                                    <label for="productname-field" class="form-label">Voucher Date</label>
                                                    <input type="date" class="form-control" placeholder="Enter Voucher Date" id="firstNameinput" />
                                                       
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div >
                                                    <label for="productname-field" class="form-label">Voucher Number</label>
                                                    <input type="number" class="form-control" placeholder="Enter Voucher Number" id="firstNameinput" />
                                                  
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">IPD Date</label>
                                                    <input type="date" class="form-control" placeholder="Enter IPD Date" id="firstNameinput" />
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">IPD Number</label>
                                                    <input type="date" class="form-control" placeholder="Enter IPD Number" id="firstNameinput" />
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">PRN</label>
                                                    <input type="date" class="form-control" placeholder="Enter PRN" id="firstNameinput" />
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div>
                                                    <label for="productname-field" class="form-label">Patient</label>
                                                    <input type="text" class="form-control" placeholder="Enter Patient" id="firstNameinput" />
                                                      
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div>
                                                    <label for="productname-field" class="form-label">Age/Sex</label>
                                                    <input type="text" class="form-control" placeholder="Enter Age/Sex" id="firstNameinput" />
                                                      
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div>
                                                    <label for="productname-field" class="form-label">Doctor</label>
                                                    <input type="text" class="form-control" placeholder="Enter Doctor" id="firstNameinput" />
                                                      
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div>
                                                    <label for="productname-field" class="form-label">Room</label>
                                                    <input type="text" class="form-control" placeholder="Enter Room" id="firstNameinput" />
                                                      
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div>
                                                    <label for="productname-field" class="form-label">TPA Name</label>
                                                    <input type="text" class="form-control" placeholder="Enter TPA Name" id="firstNameinput" />
                                                      
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div>
                                                    <label for="productname-field" class="form-label">File Number</label>
                                                    <input type="text" class="form-control" placeholder="Enter File Number" id="firstNameinput" />
                                                      
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div>
                                                    <label for="productname-field" class="form-label">CCNA Number</label>
                                                    <input type="text" class="form-control" placeholder="Enter CCNA Number" id="firstNameinput" />
                                                      
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <br />
                                            </div>
                                            <div class="col-md-3">
                                                <div>
                                                    <label for="productname-field" class="form-label">Card Number</label>
                                                    <input type="text" class="form-control" placeholder="Enter Card Number" id="firstNameinput" />
                                                      
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div>
                                                    <label for="productname-field" class="form-label">Pay Mode</label>
                                                    <select class="form-control" data-trigger="" name="productname-field" id="productname-field">
                                                        <option value="Cash">Cash</option>
                                                        <option value="Online">Online</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div>
                                                    <label for="productname-field" class="form-label">Amount</label>
                                                    <input type="text" class="form-control" placeholder="Enter Amount" id="firstNameinput" />
                                                      
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <br /><br />
                                            </div>
                                            
                                            <div class="col-lg-12">
                                                <div class="text-end">
                                                    <button type="submit" class="btn btn-primary">Save</button>
                                                    &nbsp;&nbsp;&nbsp;
                                                    <button type="button" class="btn btn-dark">Print Receipt</button>
                                                    &nbsp;&nbsp;&nbsp;
                                                    <button type="button" class="btn btn-light">Sample Receipt</button>
                                                </div>
                                            </div>

                                        </div>

                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TpaAdvRec;
